module.exports = __webpack_public_path__ + "static/home-image-d6a32eb11243aff131227ae2fbd9f236.jpg";